import { Component, OnInit, Input } from '@angular/core';
import { User } from '@app/model/user';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FeedsService } from '@app/services/feeds/feeds.service';
import { FeedRating } from '@app/model/feedsRating';
import { UserService } from '@app/services/User/user.service';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { BusinessSliderInfo } from '@app/model/business-slider-info';
import { Product } from '@app/model/product';
import { ProductService } from '@app/services/Product/product.service';
import { environment } from '../../../../environments/environment.prod';
import Swal from 'sweetalert2';
import { ImageCompressionService } from '@app/services/image-compression.service';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {
  addFeedForm!: FormGroup;

  rating: any;
  businessUser: any;
  userInfoId: any;
  productInfoId: any;

  feedRating: any;
  feedList: any;
  feedTotal: any;
  feedAvg: any;

  businessId: any;
  feedPhotoUrl: any;
  
  businessPhoto: any; 
  businessSlider:any;

  productPhoto:any;
  productDetails:any;

  constructor(
    private fb: FormBuilder,
    private feedsService: FeedsService,
    private userService: UserService,
    private businessService: BusinessDetailsService,
    private productService: ProductService,
    private imageCompressionService: ImageCompressionService,
    private route: ActivatedRoute) {
    this.businessUser = new User();
  }
  serverImgUrl = environment.IMG_URL;

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userInfoId = params['uid'];
      this.productInfoId = params['id'];

      if (this.userInfoId != null && this.productInfoId == null) {
        this.fetchFeedsByBusinessUUID(); // fetch business review
      } else {
        this.fetchFeedsByProduct(); // fetch product review
      }

    })

    this.addFeedForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      feedMessage: ['', Validators.required],
      feedPhoto: File || null,
    });
  }

  // Child starRating.component rating value catch here for submit review. 
  items = [1]
  setRating(newRating:number){
    this.rating = newRating;
    this.feedRating = newRating;
  } 

 // Review form start
  async onSelectFeedPhoto(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      try {
        this.feedPhotoUrl = await this.imageCompressionService.compress(input.files[0]);
      } catch (error) {
        console.error('Image compression failed:', error);
        this.feedPhotoUrl = null;
        input.value = '';
        Swal.fire('Unable to compress this image. Please choose another image.');
      }
    }
  }

  get fbReview() {
    return this.addFeedForm.controls;
  }

  submitFeedInfo(): void {
    if (this.addFeedForm.invalid) {
      Swal.fire("Please fill the form fields.");
      return;
    }

    const formData = new FormData();
    if (this.userInfoId != null && this.productInfoId == null) {
      this.fetchSliderProductById(); // get business photo for post new review
      this.fetchBusinessUserById(); // get businessId email
      formData.append('productInfoId', '');
      formData.append('businessPhoto', this.businessPhoto);
    } else {
      this.fetchProductDetailsById(); // get product photo for post new review
      this.fetchBusinessUserById(); // get businessId email
      formData.append('productInfoId', this.productInfoId);
      formData.append('businessPhoto', this.productPhoto);
    }

    formData.append('userInfoId', this.userInfoId);
    formData.append('businessId', this.businessId);
    formData.append('email', this.fbReview['email'].value);
    formData.append('name', this.fbReview['name'].value);
    formData.append('feedMessage', this.fbReview['feedMessage'].value);
    formData.append('feedPhoto', this.feedPhotoUrl);
    formData.append('feedRating', this.feedRating);
    this.feedsService.addBusinessFeeds(formData).subscribe({
      next: (response: any) => {
        if (this.userInfoId != null && this.productInfoId == null) {
          this.fetchFeedsByBusinessUUID(); // fetch business review
        } else {
          this.fetchFeedsByProduct(); // fetch product review
        }
        
        this.addFeedForm.reset();
     
        Swal.fire({
          title: response.message,
          icon: "success",
          showConfirmButton: false,
          timer: 2000
        });
      },
      error: (error: any) => {
        Swal.fire({
          title: `Error adding review.`,
          icon: "error",
          showConfirmButton: false,
          timer: 2000
        });
        console.error(error);
      }
    });
  }
  // Review form start

  // Below API return business feeds
  fetchFeedsByBusinessUUID(): void {
    this.feedsService.fetchFeedsByBusinessUUID(this.userInfoId)
      .subscribe({
        next: (p) => {
          this.feedList = p as FeedRating;
          this.feedTotal = this.feedList.data.length;
          var sum = 0;
          if (this.feedList.data != null && this.feedList.data.length > 0) {
            for (var i = 0; i < this.feedList.data.length; i++) {
              sum += this.feedList.data[i].feedRating;
            }
            this.feedAvg = sum / this.feedList.data.length;
          }
          else {
            this.feedAvg = 0;
          }
        }
      });
  }

   // Below API return products feeds
  fetchFeedsByProduct(): void {
    this.feedsService.fetchFeedsByProduct(this.userInfoId, this.productInfoId)
      .subscribe({
        next: (p) => {
          this.feedList = p as FeedRating;
          this.feedTotal = this.feedList.data.length;
          var sum = 0;
          if (this.feedList.data != null && this.feedList.data.length > 0) {
            for (var i = 0; i < this.feedList.data.length; i++) {
              sum += this.feedList.data[i].feedRating;
            }
            this.feedAvg = sum / this.feedList.data.length;
          }
          else {
            this.feedAvg = 0;
          }
        }
      });
  }

  fetchBusinessUserById(): void {
    this.userService.getById(this.userInfoId)
      .subscribe({
        next: (p) => {
          this.businessUser = p as User;
          this.businessId = this.businessUser.data[0].UserName;
        }
      }
      )
  }

  fetchSliderProductById(): void {
    this.businessService.getSliderImageByUUId(this.userInfoId)
      .subscribe({
        next: (p) => {
          this.businessSlider = p as BusinessSliderInfo;
          if (this.businessSlider.data != null && this.businessSlider.data.length > 0) {
            this.businessPhoto = this.businessSlider.data[0].businessImageURL;
          }
          else {
            this.businessPhoto = 'no-image.jpg';
          }
        }
      });
  }
  
  fetchProductDetailsById(): void {
    this.productService.getSellerProductByUUID_Id(this.productInfoId, this.userInfoId)
      .subscribe({
        next: (p) => {
          this.productDetails = p as Product;
          if (this.productDetails.data != null && this.productDetails.data.length > 0) {
            this.productPhoto = this.productDetails.data[0].sellProductImageURL;
          }
          else {
            this.productPhoto = 'no-image.jpg';
          }
        } 
      });
  }
}